// ** Redux Imports
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import * as companiesApi from '../../api'

export const getCompaniesStatus = createAsyncThunk('appCompaniesStatus/getCompaniesStatus', async () => {
    return {
        data: await companiesApi.fetchCompaniesStatus()
    }
})

export const addCompanyStatus = createAsyncThunk('appCompaniesStatus/addCompanyStatus', async (company, { dispatch }) => {
    const data = await companiesApi.createCompanyStatus(company)
    await dispatch(getCompaniesStatus())
    return {
        data
    }
})

export const appCompaniesStatusSlice = createSlice({
    name: 'appCompaniesStatus',
    initialState: {
        data: []
    },
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getCompaniesStatus.fulfilled, (state, action) => {
            state.data = action.payload.data
        })
    }
})

export default appCompaniesStatusSlice.reducer